import { defineMessages } from 'react-intl';

export const findPasFieldLabels = defineMessages({
  amcrId: { id: 'findPasEdit.field.amcrId', defaultMessage: 'AMCR-ID' },
  foundBy: { id: 'findPasEdit.field.foundBy', defaultMessage: 'Finder' },
  situationType: {
    id: 'findPasEdit.field.situationType',
    defaultMessage: 'Situation',
  },
  depth: { id: 'findPasEdit.field.depth', defaultMessage: 'Depth (cm)' },
  count: { id: 'findPasEdit.field.count', defaultMessage: 'Count' },
  latitude: { id: 'general.latitude', defaultMessage: 'Latitude' },
  longitude: { id: 'general.longitude', defaultMessage: 'Longitude' },
  description: { id: 'form.description', defaultMessage: 'Description' },
});

export const findPasEditMessages = defineMessages({
  failed: {
    id: 'findPasEdit.failed',
    defaultMessage: 'The find could not be saved.',
  },
});
